













import { Component, Mixins, Prop, Provide, Watch } from 'vue-property-decorator';
import MixinCharts from '@/plugins/podolib/services/helper/mixins/chart/standard';

@Component
export default class ChartRunningPhaseStrikePattern extends Mixins(MixinCharts) {
  @Prop({ required: false, default: true }) globalType!: boolean;
  @Prop({ required: false, default: 0 }) index!: number;

  getForeFoot(side: string) {
    let count: number = 0;
    for (const seg of this.values.segments) {
      if (seg[side].result.scalars.fore_foot) {
        count = count + 1;
      }
    }
    if (this.globalType) {
      if (this.values.segments.length / 2 < count) {
        return 'attack-toe';
      } else {
        return 'attack-heel';
      }
    } else {
      let isLastAnalysis =
        this.values.segments[this.index][side].result.scalars.mid_foot === undefined &&
        this.values.segments[this.index][side].result.scalars.rear_foot === undefined;
      if (isLastAnalysis) {
        return this.values.segments[this.index][side].result.scalars.fore_foot ? 'attack-toe' : 'attack-heel';
      } else {
        const highestValue = Math.max(
          this.values.segments[this.index][side].result.scalars.fore_foot.avg,
          this.values.segments[this.index][side].result.scalars.mid_foot.avg,
          this.values.segments[this.index][side].result.scalars.rear_foot.avg,
        );
        if (highestValue === this.values.segments[this.index][side].result.scalars.fore_foot.avg) {
          return 'attack-toe';
        } else if (highestValue === this.values.segments[this.index][side].result.scalars.rear_foot.avg) {
          return 'attack-heel';
        } else {
          return 'attack-flat';
        }
      }
    }
  }
}
